import script from "./TableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TableView.vue?vue&type=script&setup=true&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=52c9f1f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c9f1f3"]])

export default __exports__